import styled, { css } from 'styled-components';
import { mediaQueries } from '@fourthwall/components';
export const Container = styled.div `
  background-color: var(--bg-pro);
  color: var(--text-pro);
  display: flex;
  flex-direction: column;
  gap: var(--space-300);
  padding: var(--space-300) var(--space-400);
  align-items: center;

  ${mediaQueries.tablet} {
    flex-direction: row;
    gap: var(--space-600);
  }

  ${({ $layout }) => $layout === 'vertical' &&
    css `
      ${mediaQueries.tablet} {
        gap: var(--space-300);
        flex-direction: column;
      }
    `}
`;
export const ContentContainer = styled.div `
  flex: 1;
  color: var(--text-pro);
  font-size: var(--font-size-400);
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-400); /* 150% */
  letter-spacing: var(--font-letter-spacing-normal);

  b,
  strong {
    font-weight: var(--font-weight-medium);
  }
`;
